import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ToolbarModule } from 'primeng/toolbar';

@Component({
  selector: 'lib-header',
  imports: [ButtonModule, TooltipModule, ToolbarModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  public readonly isToggleVisible = input(false);
  public readonly isToggled = input(false);
  public readonly toggleTooltip = input('');
  public readonly toggleChange = output<boolean>();

  protected onToggle(): void {
    this.toggleChange.emit(!this.isToggled());
  }
}
